import React from 'react'
import Select from 'react-select'
import {FormikErrors} from 'formik'

export function ReactSelectInput({
  isMulti = false,
  options = [],
  placeholder,
  label,
  required = false,
  onChange,
  value,
  disabled = false,
  error,
  isClearable = true,
  maxMenuHeight,
}: ReactSelectInputProps) {
  return (
    <div className='my-1'>
      {label && <label className={`pb-1 fw-bold ${required ? 'required' : ''}`}>{label}</label>}
      <Select
        isClearable={isClearable}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        placeholder={placeholder}
        options={options}
        isDisabled={disabled}
        maxMenuHeight={maxMenuHeight}
        menuPlacement='auto'
        menuPosition="fixed"
        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
        filterOption={(option, rawInput) => {
          const query = rawInput.trim().toLowerCase()
          if (!query) return true
          if (String(option.value).toLowerCase().includes(query)) return true
          const extra = (option.data as {search?: string}).search
          if (typeof extra === 'string') return extra.toLowerCase().includes(query)
          if (typeof option.label === 'string') return option.label.toLowerCase().includes(query)
          return true
        }}
        styles={{
          menuPortal: (base) => ({ 
            ...base, 
            zIndex: 99999 
          }),
          menu: (base) => ({ 
            ...base, 
            zIndex: 99999 
          }),
          control: (base) => ({
            ...base,
            ...(error ? { borderColor: '#dc3545' } : {}),
          }),
        }}
      />
      {error && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block py-2'>
            <span className='text-danger fw-bold' role='alert'>
              {error}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

interface ReactSelectInputProps {
  isMulti?: boolean
  options?: {value: any; label: string | React.ReactNode}[]
  placeholder?: string | React.ReactNode
  label?: string | React.ReactNode
  required?: boolean
  onChange?: (value: any) => void
  value?: any
  disabled?: boolean
  error?: FormikErrors<string>
  isClearable?: boolean
  maxMenuHeight?: number
}
